"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, FlexColumn, ModalBody, ModalHeader, ModalHeaderTitle, SpaceBetween, TextBody, TextLabel } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import React from "react";
import { Key } from "./Key";
import { useKeybinds } from "./keybinds";
export function KeyboardShortcutsModalLayout() {
  const $ = _c(14);
  const t = useTranslations("KeyboardShortcutsModalLayout");
  const keybinds = useKeybinds();
  let t0;
  if ($[0] !== t) {
    t0 = t("shortcuts");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <ModalHeader><ModalHeaderTitle>{t0}</ModalHeaderTitle></ModalHeader>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== keybinds || $[5] !== t) {
    let t3;
    if ($[7] !== t) {
      t3 = t4 => {
        const [keybind, keybindInfo] = t4;
        return keybindInfo.help ? <SpaceBetween key={keybind}><TextBody weight="semibold">{keybindInfo.help.description}</TextBody><FlexCenter className="gap-2">{keybindInfo.help.keys.map((keys, x) => <React.Fragment key={x}><FlexCenter className="gap-1">{keys.map((key, y) => <React.Fragment key={y}><Key>{key}</Key>{y < (keys.length || 0) - 1 && <TextLabel className="lowercase opacity-75" size="xs">{t("then")}</TextLabel>}</React.Fragment>)}</FlexCenter>{x < (keybindInfo.help?.keys.length || 0) - 1 && <TextLabel className="opacity-75" size="xs">{t("or")}</TextLabel>}</React.Fragment>)}</FlexCenter></SpaceBetween> : null;
      };
      $[7] = t;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = Object.entries(keybinds).map(t3).filter(_temp);
    $[4] = keybinds;
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <ModalBody><FlexColumn className="gap-5">{t2}</FlexColumn></ModalBody>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function _temp(e) {
  return Boolean(e);
}